module.exports = __webpack_public_path__ + "static/media/gw.50cec7fd.svg";